const enhanceAlpineProduct = () => {
  const root = document.querySelector('.alpine-product-main');
  const assetsNode = document.querySelector('[data-alpine-v46-assets]');
  if (!root || !assetsNode || root.dataset.v46Enhanced === 'true') return;

  root.dataset.v46Enhanced = 'true';
  root.classList.add('alpine-product-main--v46');

  const media = root.querySelector('.alpine-product-main__media');
  const mainImage = media?.querySelector(':scope > img');

  if (media && mainImage) {
    mainImage.classList.add('alpine-product-main__hero-image');
    mainImage.dataset.galleryMain = 'true';

    const oldHighlights = media.querySelector('.alpine-product-main__thumbs');
    oldHighlights?.remove();

    const galleryItems = [
      { key: 'studio', label: 'Product', alt: 'Pair of black Alpine Guards Pro ski-boot cushioning sleeves' },
      { key: 'inuse', label: 'In use', alt: 'Skier wearing Alpine Guards Pro over ski socks before putting on ski boots' },
      { key: 'designed', label: 'Designed for comfort', alt: 'Alpine Guards Pro designed for comfort infographic showing honeycomb EVA cushioning, low-bulk profile, flexible stretch sleeve and silicone grip strips' },
      { key: 'how', label: 'How it works', alt: 'How Alpine Guards Pro sit between the shin and ski-boot tongue' },
      { key: 'closeup', label: 'Cushioning detail', alt: 'Close-up of Alpine Guards Pro honeycomb EVA cushioning' }
    ].filter((item) => assetsNode.dataset[item.key]);

    if (galleryItems.length) {
      mainImage.src = assetsNode.dataset[galleryItems[0].key];
      mainImage.alt = galleryItems[0].alt;
    }

    const thumbRail = document.createElement('div');
    thumbRail.className = 'alpine-product-main__gallery-thumbs';
    thumbRail.setAttribute('aria-label', 'Product images');

    galleryItems.forEach((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'alpine-product-main__gallery-thumb';
      button.dataset.galleryIndex = String(index);
      button.setAttribute('aria-label', `View ${item.label.toLowerCase()}`);
      button.setAttribute('aria-pressed', String(index === 0));

      const image = document.createElement('img');
      image.src = assetsNode.dataset[item.key];
      image.alt = '';
      image.loading = 'lazy';
      button.appendChild(image);
      thumbRail.appendChild(button);

      button.addEventListener('click', () => {
        mainImage.src = assetsNode.dataset[item.key];
        mainImage.alt = item.alt;
        thumbRail.querySelectorAll('[data-gallery-index]').forEach((thumb) => {
          thumb.setAttribute('aria-pressed', String(thumb === button));
        });
      });
    });

    mainImage.insertAdjacentElement('afterend', thumbRail);

    const mobileGallery = document.createElement('div');
    mobileGallery.className = 'alpine-product-main__mobile-gallery';
    mobileGallery.innerHTML = '<div class="alpine-product-main__mobile-track" aria-label="Product gallery"></div><p>Swipe to explore Alpine Guards Pro</p>';
    const mobileTrack = mobileGallery.querySelector('.alpine-product-main__mobile-track');

    galleryItems.forEach((item, index) => {
      const slide = document.createElement('figure');
      slide.className = 'alpine-product-main__mobile-slide';
      slide.dataset.mobileGalleryIndex = String(index);
      const image = document.createElement('img');
      image.src = assetsNode.dataset[item.key];
      image.alt = item.alt;
      image.loading = index === 0 ? 'eager' : 'lazy';
      slide.appendChild(image);
      mobileTrack.appendChild(slide);
    });

    thumbRail.insertAdjacentElement('afterend', mobileGallery);

    const syncSelectedColor = () => {
      queueMicrotask(() => {
        const firstMobileImage = mobileGallery.querySelector('[data-mobile-gallery-index="0"] img');
        const firstThumbImage = thumbRail.querySelector('[data-gallery-index="0"] img');
        if (firstMobileImage) {
          firstMobileImage.src = mainImage.src;
          firstMobileImage.alt = mainImage.alt;
        }
        if (firstThumbImage) firstThumbImage.src = mainImage.src;
        thumbRail.querySelectorAll('[data-gallery-index]').forEach((thumb, index) => {
          thumb.setAttribute('aria-pressed', String(index === 0));
        });
        if (window.matchMedia('(max-width: 989px)').matches) {
          mobileTrack.scrollTo({ left: 0, behavior: 'smooth' });
        }
      });
    };

    root.querySelector('.alpine-product-bundle')?.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-position="1"], input[name="alpine_bundle"]')) {
        syncSelectedColor();
      }
    });
  }

  const price = root.querySelector('.alpine-product-main__price');
  if (price && !price.querySelector('.alpine-product-main__save-badge')) {
    const values = [...price.textContent.matchAll(/\$([0-9,.]+)/g)]
      .map((match) => Number(match[1].replace(',', '')))
      .filter((value) => Number.isFinite(value));
    if (values.length >= 2 && values[1] > values[0]) {
      const percent = Math.round((1 - values[0] / values[1]) * 100);
      const badge = document.createElement('span');
      badge.className = 'alpine-product-main__save-badge';
      badge.textContent = `SAVE ${percent}%`;
      price.appendChild(badge);
    }
  }

  const bundle = root.querySelector('.alpine-product-bundle');
  const benefits = root.querySelector('.alpine-product-main__benefits');
  if (bundle && benefits) bundle.insertAdjacentElement('afterend', benefits);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enhanceAlpineProduct, { once: true });
} else {
  enhanceAlpineProduct();
}
